export const APP_CONFIG = {

  // API
  API_BASE_URL:
    // "http://localhost:5000/api",
    "https://api.lunasearch.app/api",

  BASE_FRONTEND_URL: "https://lunasearch.app",

  BASE_BACKEND_URL: "https://api.lunasearch.app/api",

  BASE_DEV_URL: "https://localhost:5000/api",

  COMMISSION_RATE: 0.7,


  // PRICING
  PRICES: {

    plans: {
      custom: 100,
      pro: 253,
      ultimate: 299,
    },
    blockchainUnitPrice: 49,

  },


};
